import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";

export class MapUtils {
    constructor() {}

    /**
     * Berechnet den Minimalen Extent
     *
     * @param {__esri.Geometry | __esri.Geometry[]} geometries: Einzelne Geometry oder Array mit Geometrien
     * @param {number} length: Minimale Länge/Breite des Extent, default 100 Meter
     * @returns {Extent}: Minimaler Extent
     */
    static calculateMinExtent(geometries: __esri.Geometry | __esri.Geometry[], length?: number): __esri.Extent {
        const geometry = Array.isArray(geometries)? geometryEngine.union(geometries): geometries;
        let extent = geometry.extent;
        // Extent mit mindestens 100x100 Meter sicherstellen
        // TODO: In config verschieben
        const x = length? length: 100;
        if (!extent) {
            const buffer = geometryEngine.buffer(geometry, x/2, "meters");
            if(Array.isArray(buffer)) {
                extent = buffer[0].extent;
            } else if (buffer.extent) {
                extent = buffer.extent;
            }
        }else if(extent.width < 100 || extent.height < 100) {
            if(extent.width < 100){
                const xPadding = Math.ceil((x - extent.width)/2);
                extent.xmin-=xPadding;
                extent.xmax+=xPadding;
            }
            if(extent.height < 100){
                const yPadding = Math.ceil((x - extent.height)/2);
                extent.ymin-=yPadding;
                extent.ymax+=yPadding;
            }
        }
        return extent;
    }

}

